import useIsFeatureEnabled from './useIsFeatureEnabled';

const useIsMyLearningEnabled = () => {
  const isFeatureEnabled = useIsFeatureEnabled('PA-4045-My-Learning');

  return isFeatureEnabled;
};

export default useIsMyLearningEnabled;
